module.exports = __webpack_public_path__ + "img/app1.87d99361.png";